import { render, staticRenderFns } from "./AllArchiveTransection.vue?vue&type=template&id=eeb09b7e&scoped=true&"
import script from "./AllArchiveTransection.vue?vue&type=script&lang=js&"
export * from "./AllArchiveTransection.vue?vue&type=script&lang=js&"
import style0 from "./AllArchiveTransection.vue?vue&type=style&index=0&id=eeb09b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb09b7e",
  null
  
)

export default component.exports